// extracted by mini-css-extract-plugin
export default {"bucket":"Bucket-module__bucket--PrJky","item-count":"Bucket-module__item-count--VAjPX"};